import React, {useState, useEffect} from 'react';
import * as S from './ProfileInfo.styles';
import {useSelector, useDispatch} from 'react-redux';
import {createSelector} from 'reselect';
import {
  updateAadharNumber,
  submitAadharOTP,
  updateEmailId,
  verifyEmailId,
  unlinkMobileNo,
  updateMobileNo,
  emailVerify,
  verifyUpdatedEmail,
  verifyUpdatedEmailOtp,
  updateTdsSlab,
  unMaskDataOTP,
  verifyUnMaskDataOTP,
  maskData,
} from '@ibibo/myaccount-reducer';
import {sendEvarData} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';
import ButtonLoader from '../../../../../../../onboarding/src/stories/components/UI/Loader/Loader';
import IconSelector from '@ibibo/icon-selector';
import {
  userSettingDataSelector,
  setUserSetting,
  supportInfoDataSelector,
  dataMaskedSelector,
} from '@ibibo/myaccount-reducer';

import {validations} from '../../../../../utils/validations';

import AadharOtpVerify from './AadharOtpVerify/AadharOtpVerify';
import Modal, {useModal} from '../../../../../../../hotels-dweb/src/shared/components/Modal';
import EmailOtpVerify from './EmailOtpVerify/EmailOtpVerify';
import Spinner from '../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/Spinner/Spinner';
import EmailVerified from './EmailVerified/EmailVerified';
import UnlinkMobilePop from './UnlinkMobilePop/UnlinkMobilePop';
import UpdateMobile from './UpdateMobilePop/UpdateMobile';
import MobileVerified from './MobileVerified/MobileVerified';
import UpdateDetailsForm from '../../../common/Form/UpdateDetailsForm/UpdateDetailsForm';
import OtpVerfied from '../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';
import UpdateEmail from './UpdateEmail/UpdateEmail';
import MobilePop from './Masking/MobilePop';

const ProfileInfo = ({userData, handleAgreementClick, fetchData, sendTrackingDataToSdk}) => {
  const data_masked = useSelector(dataMaskedSelector);
  const dispatch = useDispatch();
  const history = useHistory();
  const {isModalOpen, openModal, closeModal} = useModal();

  const [clientId, setClientId] = useState('');
  const [otpError, setOtpError] = useState('');
  const [errors, setError] = useState({});
  const [aadharError, setAadharError] = useState('');

  const [resendOtpActive, setResendOtpActive] = useState(true);
  const [resentCounter, setResendCounter] = useState(0);
  const [showPop, setShowPop] = useState(false);
  const [emailOtpError, setEmailOtpErrpr] = useState('');
  const [resendEmailOtpActive, setResendEmailOtpActive] = useState(true);
  const [emailCounter, setEmailCounter] = useState(0);
  const [emailExist, setEmailExist] = useState(false);
  const [showVerifiedPop, setShowVerifiedPop] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [showLoyaltyAgreementFlag, setLoyaltyAgreementFlag] = useState(
    userData?.tnc_completed?.loyalty_accepted,
  );
  const [showUpdateAgremeentRow, setShowUpdateAgreementRow] = useState(true);
  /**Update Email new steps */
  const [openModalFlag, setOpenModalFlag] = useState(false);
  const [modalData, setModalData] = useState({});
  const [popupType, setPopupType] = useState('');
  const [currentModalRow, setCurrentModalRow] = useState('');
  const errorsInitialState = {
    formSubmissionError: '',
    inputBoxError: '',
  };
  const [errorForm, setErrorForm] = useState(errorsInitialState);
  const [communicationAddress, setCommunicationAddress] = useState('');
  /**update email new steps end here */

  const [showUnlinkPop, setShowUnlikPop] = useState(false);
  const [showToggleMaskPop, setShowToggleMaskPop] = useState(false);
  const [unlinkOtpError, setUnlikOtpError] = useState('');
  const [maskOtpError, setMaskOtpError] = useState('');
  const [resendUnlinkOtpActive, setResendUnlinkOtpActive] = useState(true);
  const [resendMaskOtpActive, setResendMaskOtpActive] = useState(true);
  const [unlinkCounter, setUnlinkCounter] = useState(0);
  const [maskCounter, setMaskCounter] = useState(0);

  const [showUpdateMobilePop, setUpdateMobilePop] = useState(false);
  const [updateOtpError, setUpdateOtpError] = useState('');
  const [mobileExist, setMobileExist] = useState(true);
  const [showMobileVerify, setMobileVerify] = useState(false);
  const [resendUpdateActive, setResendUpdateActive] = useState(true);
  const [updateCounter, setUpdateCounter] = useState(0);

  const [showUpdateEmail, setShowUpdateEmail] = useState(false);
  const [showNewEmailInput, setShowNewEmailInput] = useState(true);
  const [newEmail, setNewEmail] = useState('');
  const [showSpinnerUpdateTds, setShowSpinnerUpdateTds] = useState(false);

  const [
    {
      first_name,
      last_name,
      email,
      pan_card,
      gstin,
      username,
      aadhar_number,
      mobile_number,
      booking_tds,
      benefit_tds,
      is_sub_user,
    },
    setUserInfo,
  ] = useState({
    first_name: userData.first_name ? userData.first_name.value : '',
    last_name: userData.last_name ? userData.last_name.value : '',
    email: userData.email ? userData.email.value : '',
    pan_card: userData.pan_card ? userData.pan_card.value : '',
    gstin: userData.gstin ? userData.gstin.value : '',
    username: userData.username ? userData.username.value : '',
    aadhar_number: userData.aadhar_number ? userData.aadhar_number.value : '',
    mobile_number: userData.mobile_number ? userData.mobile_number.value : '',
    booking_tds: userData.booking_tds?.value ?? '',
    benefit_tds: userData.benefit_tds?.value ?? '',
    is_sub_user: userData.is_sub_user ? userData.is_sub_user : false,
  });

  let isLoading = useSelector(
    createSelector(
      state => state?.user || {},
      item => item?.isLoading || false,
    ),
  );
  let isEmailLoading = useSelector(
    createSelector(
      state => state?.user || {},
      item => item?.isEmailLoading || false,
    ),
  );
  let isSendOtpLoading = useSelector(
    createSelector(
      state => state?.user || {},
      item => item?.isSendOtpLoading || false,
    ),
  );

  const fieldValidators = {
    aadhar_number: {
      field: 'aadhar_number',
      fieldName: 'Aadhar Number',
      validators: ['required', 'validAadharNumber', 'numeric'],
    },
  };

  const validateFields = data => {
    let errorObj = {};
    setError({});
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    setUserInfo({
      first_name: userData.first_name ? userData.first_name.value : first_name,
      last_name: userData.last_name ? userData.last_name.value : last_name,
      email: userData.email ? userData.email.value : email,
      pan_card: userData.pan_card ? userData.pan_card.value : pan_card,
      gstin: userData.gstin ? userData.gstin.value : gstin,
      username: userData.username ? userData.username.value : username,
      aadhar_number: userData.aadhar_number ? userData.aadhar_number.value : aadhar_number,
      mobile_number: userData?.mobile_number?.value ? userData.mobile_number.value : mobile_number,
      booking_tds: userData?.booking_tds?.value ? userData.booking_tds.value : booking_tds,
      benefit_tds: userData?.benefit_tds?.value ? userData.benefit_tds.value : benefit_tds,
      is_sub_user: userData.is_sub_user ? userData.is_sub_user : false,
    });
  }, [userData]);

  useEffect(() => {
    if (currentModalRow && popupType) {
      setModalData(userData?.email?.data[popupType]);
    }
  }, [popupType, currentModalRow]);

  useEffect(() => {
    setLoyaltyAgreementFlag(userData?.tnc_completed?.loyalty_accepted);
    setShowUpdateAgreementRow(userData?.tnc_completed?.agreement_row?.show);
  }, [userData]);

  let aadharStatus = '';
  if (userData.aadhar_number) {
    aadharStatus = userData.aadhar_number.status;
  }

  const onChangeHandler = (field, value) => {
    if (field === 'aadhar_number') {
      const re = /^[0-9]+$/;
      if (value !== '' && !re.test(value)) {
        return;
      }
    }
    const dataObj = {
      first_name,
      last_name,
      email,
      pan_card,
      gstin,
      username,
      aadhar_number,
    };
    dataObj[field] = value;
    setUserInfo(dataObj);
  };

  const successCallback = response => {
    if (response.aadhar_number.status) {
      openModal();
      setClientId(response.aadhar_number.client_id);
    }
  };

  const errorCallback = response => {
    // setUserInfo(false);
    if (!response.aadhar_number.success && response.aadhar_number.client_id === '') {
      setOtpError(response.aadhar_number.message);
      setAadharError(response.aadhar_number.message);
    } else if (!response.aadhar_number.success) {
      setAadharError(response.aadhar_number.message);
    }
  };

  const updateUserAadhar = (event: React.FormEvent) => {
    event.preventDefault();
    const data = {aadhar_number};
    const hasError = validateFields(data);
    if (!hasError) {
      dispatch(updateAadharNumber(data, successCallback, errorCallback));
    }
    setOtpError('');
    setAadharError('');
  };

  const resendOtp = () => {
    const data = {aadhar_number};
    const hasError = validateFields(data);
    setResendCounter(resentCounter + 1);
    if (!hasError) {
      dispatch(updateAadharNumber(data, successCallback, errorCallback));
    }
    setOtpError('');
    setAadharError('');
  };

  useEffect(() => {
    if (resentCounter > 2) {
      setResendOtpActive(false);
    }
  }, [resentCounter]);

  const submitAadharOtp = data => {
    if (data.length < 4) {
      setOtpError('Invalid OTP. Please enter the correct OTP.');
    }
    const dataObj = {
      aadhar_number,
      client_id: clientId,
      otp_aadhar: data,
    };
    dispatch(submitAadharOTP(dataObj, successCallOtp, errorCallOtp));
  };

  const successCallOtp = response => {
    if (response.aadhar_number.success) {
      closeModal();
      setOtpError('');
      setAadharError('');
    }
  };

  const errorCallOtp = response => {
    if (!response.aadhar_number.success && response.aadhar_number.client_id === '') {
      setOtpError(response.aadhar_number.message);
    } else {
      setOtpError(response.aadhar_number.message);
    }
  };

  let aadharBlock = !is_sub_user && (
    <>
      <S.InfoText>{aadhar_number}</S.InfoText>
      <S.VerifiedTag>
        <IconSelector iconKey="greenmultitick" />
        <S.VerifiedText>Verified</S.VerifiedText>
      </S.VerifiedTag>
    </>
  );
  switch (aadharStatus) {
    case 'provide':
      aadharBlock = (
        <S.AadharForm onSubmit={updateUserAadhar}>
          <S.AadharInputWrap>
            <S.CommonInput
              type="text"
              name="aadhar_number"
              value={aadhar_number}
              onChange={event => onChangeHandler('aadhar_number', event.target.value)}
              placeholder="Your Aadhar Number"
              hasError={errors['aadhar_number'] ? true : false}
              maxLength="12"
            />
            {(aadharError && (
              <S.ErrorText weight="800" fontSize={'1.2rem'}>
                {aadharError}
              </S.ErrorText>
            )) || (
              <S.ErrorText weight="800" fontSize={'1.2rem'}>
                {errors['aadhar_number']}
              </S.ErrorText>
            )}
            {!aadharError && !Object.keys(errors).length && (
              <S.InfoWrapper>
                <S.ErrorTextDiv>
                  <IconSelector
                    props={{width: '2.8rem', height: '2.2rem'}}
                    iconKey="failedactive"
                  />
                </S.ErrorTextDiv>
                <S.ErrorTextDiv weight="800" fontSize={'1.2rem'} paddingTop="1rem">
                  Verify Aadhaar to complete your myPartner profile
                </S.ErrorTextDiv>
              </S.InfoWrapper>
            )}
          </S.AadharInputWrap>
          <S.VerifyBtn type="Submit">
            {isLoading && !isModalOpen ? <ButtonLoader loaderType="button" /> : 'Verify'}
          </S.VerifyBtn>
        </S.AadharForm>
      );

      break;

    case 'pending':
      aadharBlock = (
        <S.AadharForm onSubmit={updateUserAadhar}>
          <S.AadharInputWrap>
            <S.CommonInput
              type="text"
              name="aadhar_number"
              value={aadhar_number}
              onChange={event => onChangeHandler('aadhar_number', event.target.value)}
              maxLength="12"
            />
            {(aadharError && (
              <S.ErrorText weight="800" fontSize={'1.2rem'}>
                {aadharError}
              </S.ErrorText>
            )) || (
              <S.ErrorText weight="800" fontSize={'1.2rem'}>
                {errors['aadhar_number']}
              </S.ErrorText>
            )}
            {!aadharError && !Object.keys(errors).length && (
              <S.InfoWrapper>
                <S.ErrorTextDiv>
                  <IconSelector
                    props={{width: '2.8rem', height: '2.2rem'}}
                    iconKey="failedactive"
                  />
                </S.ErrorTextDiv>
                <S.ErrorTextDiv weight="800" fontSize={'1.2rem'} paddingTop="1rem">
                  Verify Aadhaar to complete your myPartner profile
                </S.ErrorTextDiv>
              </S.InfoWrapper>
            )}
          </S.AadharInputWrap>
          <S.VerifyBtn type="Submit">
            {isLoading && !isModalOpen ? <ButtonLoader loaderType="button" /> : 'Verify'}
          </S.VerifyBtn>
        </S.AadharForm>
      );
      break;

    default:
      aadharBlock;
  }

  const closeVerifyPop = () => {
    setShowPop(!showPop);
    /*setUserInfo({
      first_name: userData?.first_name ? userData.first_name.value : first_name,
      last_name: userData?.last_name ? userData.last_name.value : last_name,
      email: userData?.email ? userData.email.value : email,
      pan_card: userData?.pan_card ? userData.pan_card.value : pan_card,
      gstin: userData?.gstin ? userData.gstin.value : gstin,
      username: userData?.username ? userData.username.value : username,
      aadhar_number: userData?.aadhar_number ? userData.aadhar_number.value: aadhar_number,
      mobile_number: userData?.mobile_number ? userData.mobile_number : mobile_number
    });*/
  };

  // useEffect(() => {
  //   if(!userData?.email?.is_verified){
  //     openEmailVerifyPop();
  //   }
  // },[email]);

  const openEmailVerifyPop = () => {
    sendEmailOtp({email});
  };

  const successEmailCallBack = data => {
    if (!data.email_exist) {
      setEmailExist(false);
    }
    setShowPop(true);
  };

  const successUpdateEmailCallBack = data => {
    setShowUpdateEmail(true);
    setShowNewEmailInput(false);
    setMobileExist(false);
    setEmailOtpErrpr('');
  };

  const errorEmailCallBack = data => {
    if (!data.success) {
      if (data.email_exist) {
        setEmailExist(true);
        setShowPop(true);
        setEmailOtpErrpr(data.message);
      }
    }
  };

  const errorUpdateEmailCallBack = data => {
    if (!data.success) {
      //if(data.email_exist){
      setEmailExist(true);
      setShowUpdateEmail(true);
      setEmailOtpErrpr(data.message);
      //}
    }
  };

  const successVerifyCallBack = data => {
    if (data.success) {
      setShowPop(false);
      setShowVerifiedPop(true);
    } else {
      setEmailOtpErrpr(data.message);
    }
    if (data.redirect_url !== '') {
      setRedirectUrl(data.redirect_url);
    }
  };

  const errorVerifyCallBack = data => {
    if (!data.success) {
      setEmailOtpErrpr(data.message);
      setEmailExist(true);
    }
  };

  const successVerifyUpdateCallBack = (data, email_type = 'old') => {
    if (data.success) {
      setShowUpdateEmail(false);
      setShowVerifiedPop(true);
      setUpdateOtpError('');
      setMobileExist(false);
      setEmailOtpErrpr('');
    } else {
      setEmailOtpErrpr(data.message);
    }
  };

  const deviceWidth = typeof window === 'undefined' ? 100 : window.screen.width;
  let deviceType = true;
  if (deviceWidth < 1024) {
    deviceType = false;
  } else {
    deviceType = true;
  }
  const submitEmailOtp = data => {
    if (data.length < 6) {
      setEmailOtpErrpr('Invalid OTP, please enter the correct OTP');
    } else {
      const dataObj = {
        //email,
        email_otp: data,
        //dt: deviceType
      };
      dispatch(verifyEmailId(dataObj, successVerifyCallBack, errorVerifyCallBack));
    }
  };

  const submitUpdateEmailOtp = data => {
    if (data.length < 6) {
      setEmailOtpErrpr('Invalid OTP, please enter the correct OTP');
    } else {
      const dataObj = {
        email_id: newEmail ? newEmail : email,
        email_otp: data,
      };
      dispatch(verifyUpdatedEmailOtp(dataObj, successVerifyUpdateCallBack, errorVerifyCallBack));
    }
  };

  const sendEmailOtp = data => {
    /*setUserInfo({
      first_name: userData?.first_name ? userData.first_name.value : first_name,
      last_name: userData?.last_name ? userData.last_name.value : last_name,
      email: data?.email,
      pan_card: userData?.pan_card ? userData.pan_card.value : pan_card,
      gstin: userData?.gstin ? userData.gstin.value : gstin,
      username: userData?.username ? userData.username.value : username,
      aadhar_number: userData?.aadhar_number ? userData.aadhar_number.value: aadhar_number,
      mobile_number: userData?.mobile_number ? userData.mobile_number : mobile_number
    });*/
    dispatch(emailVerify(successEmailCallBack, errorEmailCallBack));
    //ispatch(updateEmailId(data, successEmailCallBack, errorEmailCallBack));
  };

  const sendUpdateVerifiedEmail = data => {
    sendEvarData(
      {
        prop54: 'updateEmail__click',
      },
      true,
    );
    setNewEmail(data);
    dispatch(verifyUpdatedEmail(data, successUpdateEmailCallBack, errorUpdateEmailCallBack));
  };

  const resentEmailOtp = () => {
    let data = {email};
    setEmailCounter(emailCounter + 1);
    dispatch(emailVerify(successEmailCallBack, errorEmailCallBack));
    //dispatch(updateEmailId(data, successEmailCallBack, errorEmailCallBack))
  };

  const resentUpdateEmailOtp = (data = email, type = 'old') => {
    if (newEmail) {
      dispatch(
        verifyUpdatedEmail('new', newEmail, successUpdateEmailCallBack, errorUpdateEmailCallBack),
      );
    } else {
      dispatch(
        verifyUpdatedEmail('old', email, successUpdateEmailCallBack, errorUpdateEmailCallBack),
      );
    }
    sendEvarData(
      {
        prop54: 'updateEmail_resendOTP',
      },
      true,
    );
    //setEmailCounter(emailCounter + 1);
  };

  useEffect(() => {
    if (emailCounter > 2) {
      setResendEmailOtpActive(false);
    }
  }, [emailCounter]);

  const closeVerifiedPop = () => {
    setShowVerifiedPop(false);
    window.location.href = redirectUrl;
  };

  /* mobile unlink flow */
  const openUnlinkMobilePop = () => {
    if (userData?.mobile_number?.can_update && !userData?.mobile_number?.number_unlinked) {
      sendUnlinkMobileOtp({mobile: username});
      setShowUnlikPop(true);
    } else {
      setUpdateMobilePop(true);
    }
    sendEvarData(
      {
        prop54: 'updatePhone_click',
      },
      true,
    );
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Mobile Update clicked',
        },
      },
      'PROFILE',
    );
  };

  const openUpdateVerifiedEmail = () => {
    setShowUpdateEmail(true);
    setShowNewEmailInput(true);
    setMobileExist(false);
    setEmailOtpErrpr('');
  };

  const closeUpdateVerifiedEmailPop = () => {
    setShowUpdateEmail(false);
    setNewEmail('');
    setShowNewEmailInput(false);
    sendEvarData(
      {
        prop54: 'updateEmail_cancel',
      },
      true,
    );
  };

  const sendUnlinkMobileOtp = data => {
    dispatch(unlinkMobileNo(data, successUnlinkCallBack, errorUnlinkCallBack));
  };

  const successUnlinkCallBack = data => {
    setShowUnlikPop(true);
  };

  const errorUnlinkCallBack = data => {
    if (!data.success) {
      setUnlikOtpError(data.message);
    }
  };

  const closeUnlinkPop = () => {
    setShowUnlikPop(false);
  };

  const closeToggleMaskPop = () => {
    setShowToggleMaskPop(false);
  };

  const resendUnlinkOtp = () => {
    let data = {mobile: username};
    setUnlinkCounter(unlinkCounter + 1);
    dispatch(unlinkMobileNo(data, successUnlinkCallBack, errorUnlinkCallBack));
  };
  const resendMaskOtp = () => {
    let data = {mobile: username};
    setMaskCounter(maskCounter + 1);
    dispatch(unMaskDataOTP(data, successMaskCallBack, errorMaskCallBack));
  };
  useEffect(() => {
    if (unlinkCounter > 2) {
      setResendUnlinkOtpActive(false);
    }
  }, [unlinkCounter]);
  useEffect(() => {
    if (maskCounter > 2) {
      setResendMaskOtpActive(false);
    }
  }, [maskCounter]);

  const successUnlinkedCallBack = data => {
    if (data.success) {
      setUpdateMobilePop(true);
      setShowUnlikPop(false);
    }
  };

  const errorUnlinkedCallBack = data => {
    if (!data.success) {
      setUnlikOtpError(data.message);
    }
  };

  const submitUnlinkOtp = data => {
    if (data.length < 6) {
      setUnlikOtpError('Invalid OTP, please enter the correct OTP');
    } else {
      const dataObj = {
        mobile: username,
        mobile_otp: data,
        dt: deviceType,
      };
      dispatch(unlinkMobileNo(dataObj, successUnlinkedCallBack, errorUnlinkedCallBack));
    }
  };

  /* mobile update flow */
  const closeUpdatePop = () => {
    setUpdateMobilePop(false);
    sendEvarData(
      {
        prop54: 'updatePhone_cancel',
      },
      true,
    );
  };

  const successUpdateCallBack = data => {
    if (data.success) {
      setUpdateOtpError('');
      setMobileExist(false);
    }
  };

  const errorUpdateCallBack = data => {
    if (!data.success) {
      if (data.mobile_exist) {
        setMobileExist(true);
      }
      setUpdateOtpError(data.message);
    }
  };

  const submitNumber = data => {
    setUserInfo({
      first_name: userData.first_name ? userData.first_name.value : first_name,
      last_name: userData.last_name ? userData.last_name.value : last_name,
      email: userData.email ? userData.email.value : email,
      pan_card: userData.pan_card ? userData.pan_card.value : pan_card,
      gstin: userData.gstin ? userData.gstin.value : gstin,
      username: userData.username ? userData.username.value : username,
      aadhar_number: userData.aadhar_number ? userData.aadhar_number.value : aadhar_number,
      mobile_number: data.mobile,
      booking_tds: userData.booking_tds ? userData.booking_tds.value : booking_tds,
      benefit_tds: userData.benefit_tds ? userData.benefit_tds.value : benefit_tds,
      is_sub_user: userData?.is_sub_user ? userData?.is_sub_user : false,
    });
    dispatch(updateMobileNo(data, successUpdateCallBack, errorUpdateCallBack));
    sendEvarData(
      {
        prop54: 'updatePhone_verify',
      },
      true,
    );
  };

  const resendUpdateOtp = () => {
    let data = {mobile: mobile_number};
    setUpdateCounter(updateCounter + 1);
    dispatch(updateMobileNo(data, successUpdateCallBack, errorUpdateCallBack));
    sendEvarData(
      {
        prop54: 'updatePhone_resendOTP',
      },
      true,
    );
  };

  useEffect(() => {
    if (updateCounter > 2) {
      setResendUpdateActive(false);
    }
  }, [updateCounter]);

  const successUpdatedCallBack = data => {
    setMobileVerify(true);
    setUpdateMobilePop(false);
  };

  const errorUpdatedCallBack = data => {
    if (!data.success) {
      setUpdateOtpError(data.message);
    }
  };

  const submitUpdateOtp = data => {
    if (data.length < 6) {
      setUpdateOtpError('Invalid OTP, please enter the correct OTP');
    } else {
      const dataObj = {
        mobile: mobile_number,
        mobile_otp: data,
        dt: deviceType,
      };
      dispatch(updateMobileNo(dataObj, successUpdatedCallBack, errorUpdatedCallBack));
    }
  };

  const closeMobVerifiedPop = () => {
    setMobileVerify(false);
  };

  const postUpdateTdsSlab = () => {
    setShowSpinnerUpdateTds(true);
    dispatch(updateTdsSlab(successUpdatedTdsSlabCallback, errorUpdateTdsSlabCallback));
  };

  const successUpdatedTdsSlabCallback = response => {
    setShowSpinnerUpdateTds(false);
    setUserInfo({
      first_name: userData.first_name ? userData.first_name.value : first_name,
      last_name: userData.last_name ? userData.last_name.value : last_name,
      email: userData.email ? userData.email.value : email,
      pan_card: userData.pan_card ? userData.pan_card.value : pan_card,
      gstin: userData.gstin ? userData.gstin.value : gstin,
      username: userData.username ? userData.username.value : username,
      aadhar_number: userData.aadhar_number ? userData.aadhar_number.value : aadhar_number,
      mobile_number: userData?.mobile_number?.value ? userData.mobile_number.value : mobile_number,
      booking_tds: response.booking_tds.value ? response.booking_tds.value : booking_tds,
      benefit_tds: response.benefit_tds.value ? response.benefit_tds.value : benefit_tds,
      is_sub_user: userData?.is_sub_user ? userData?.is_sub_user : false,
    });
  };

  const errorUpdateTdsSlabCallback = err => {
    setShowSpinnerUpdateTds(false);
  };

  /**Update email new steps function starts here*/

  const modalClickHandler = (popupClicked, rowItem) => {
    setOpenModalFlag(openModalFlag => !openModalFlag);
    //setModalData(data);
    setCurrentModalRow(rowItem);
    setPopupType(popupClicked);
    setCurrentModalRow(rowItem);
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Email Update clicked',
        },
      },
      'PROFILE',
    );
  };

  const popupSuccessCallback = resp => {
    if (resp?.data?.POPUP_TYPE) {
      setOpenModalFlag(true);
    }
    setPopupType(resp?.data?.POPUP_TYPE);
    setCommunicationAddress(resp?.data);
    setErrorForm(errorsInitialState);
  };

  const popupErrorCallback = err => {
    setErrorForm({...err, formSubmissionError: err.message});
  };

  const closeFormModal = () => {
    setOpenModalFlag(openModalFlag => !openModalFlag);
    setErrorForm({...errorForm, formSubmissionError: ''});
  };

  /* masking flow */

  const successMaskCallBack = data => {
    setShowToggleMaskPop(true);
  };

  const errorMaskCallBack = data => {
    if (!data.success) {
      setMaskOtpError(data.message);
    }
  };
  const unMaskingOTP = data => {
    dispatch(unMaskDataOTP(data, successMaskCallBack, errorMaskCallBack));
  };
  const successMaskedOTPCallBack = data => {
    if (data.success) {
      setShowToggleMaskPop(false);
      fetchData();
    }
  };
  const errorMaskedOTPCallBack = data => {
    if (!data.success) {
      setMaskOtpError(data.message);
    }
  };
  const submitMaskOtp = data => {
    if (data.length < 6) {
      setMaskOtpError('Invalid OTP, please enter 6 digit OTP');
    } else {
      const dataObj = {
        mobile: username,
        otp: data,
        dt: deviceType,
      };
      dispatch(verifyUnMaskDataOTP(dataObj, successMaskedOTPCallBack, errorMaskedOTPCallBack));
    }
  };

  const successMaskedCallBack = data => {
    if (data.success) {
      fetchData();
      //show notification that error is there while masking and call settings api
    }
  };

  const errorMaskedCallBack = data => {
    if (!data.success) {
      //show notification that error is there while masking
    }
  };

  const toggleMasking = masked => {
    if (masked !== undefined || masked !== null) {
      if (masked) {
        unMaskingOTP({mobile: username});
        setShowToggleMaskPop(true);
      } else {
        dispatch(maskData(successMaskedCallBack, errorMaskedCallBack));
      }

      sendEvarData(
        {
          prop54: masked ? 'myp_unmask_clicked' : 'myp_mask_clicked',
        },
        true,
      );
    }
  };

  /**Update email new steps function ends here*/

  return (
    <S.ProfileMainWrap>
      <S.ProfileInnerWrap>
        <S.ProfileHeadOuterWrap>
          <S.ProfileHeadInnerWrap>
            <S.HeadMainText>Profile</S.HeadMainText>
            <S.HeadSubText>Basic info about your company</S.HeadSubText>
          </S.ProfileHeadInnerWrap>
          <S.addButton
            onClick={() => {
              toggleMasking(data_masked);
            }}
          >
            {data_masked ? 'Unhide Details' : 'Hide Details'}
          </S.addButton>
        </S.ProfileHeadOuterWrap>
        <S.ProfileInfoOuterWrap>
          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>FULL NAME</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              <S.InfoText>{first_name + ' ' + last_name}</S.InfoText>
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>Mobile number</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              <S.InfoText>+91 {mobile_number}</S.InfoText>
              {(!userData?.mobile_number?.can_update && (
                <S.VerifiedTag>
                  <IconSelector iconKey="greenmultitick" />
                  <S.VerifiedText>Verified</S.VerifiedText>
                </S.VerifiedTag>
              )) || (
                <S.VerifiedTag>
                  <S.VerifyEmailLink onClick={openUnlinkMobilePop}>Update</S.VerifyEmailLink>
                </S.VerifiedTag>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>E-mail Id</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              <S.InfoText>{email}</S.InfoText>
              {!is_sub_user ? (
                (userData?.email?.is_verified && (
                  <>
                    <S.VerifiedTag>
                      <IconSelector iconKey="greenmultitick" />
                      <S.VerifiedText>Verified</S.VerifiedText>
                    </S.VerifiedTag>
                    <S.VerifiedTag>
                      <S.VerifyEmailLink
                        onClick={e =>
                          modalClickHandler(
                            userData?.email?.data?.POPUP_TYPE,
                            userData?.email?.data,
                          )
                        }
                      >
                        Edit
                      </S.VerifyEmailLink>
                    </S.VerifiedTag>
                  </>
                )) || (
                  <S.VerifiedTag>
                    <S.VerifyEmailLink
                      onClick={e =>
                        modalClickHandler(userData?.email?.data?.POPUP_TYPE, userData?.email?.data)
                      }
                    >
                      Edit
                    </S.VerifyEmailLink>
                  </S.VerifiedTag>
                )
              ) : (
                <></>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>Pan card</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              <S.InfoText>{pan_card}</S.InfoText>
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>gstin</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              <S.InfoText>{gstin}</S.InfoText>
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>Aadhaar number</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>{aadharBlock}</S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          {benefit_tds ? (
            <S.ProfileInfoInnerWrap>
              <S.InfoTitleWrapTds>
                <S.TitleText>Benefit tds</S.TitleText>
                <S.InfoSubTextTds>
                  Applicable on wallet benefits, such as Deposit Incentive and Hero Cashback
                </S.InfoSubTextTds>
              </S.InfoTitleWrapTds>
              <S.InfoTextWrap>
                <S.InfoText>{benefit_tds || ''}%</S.InfoText>
                <S.InfoSubText>
                  As per the taxation laws, agents with a valid PAN will be treated as ITR compliant
                  if they are timely submitting tax returns
                  <br />
                  <br />
                  A TDS rate of 5% on commission and 10% on benefits is applicable for ITR Compliant
                  Agents.
                  <br />A TDS rate of 10% on commission and 20% on benefits is applicable for ITR
                  Non-compliant Agents
                  <br />
                  For all cases where ITR compliant check cannot be established, TDS will be
                  withheld at the rate of 20% for both commission and benefits
                </S.InfoSubText>
              </S.InfoTextWrap>
            </S.ProfileInfoInnerWrap>
          ) : null}

          {booking_tds ? (
            <S.ProfileInfoInnerWrap>
              <S.InfoTitleWrapTds>
                <S.TitleText>Booking tds</S.TitleText>
                <S.InfoSubTextTds>
                  Applicable on commission earned through Flight and Hotel bookings
                </S.InfoSubTextTds>
              </S.InfoTitleWrapTds>
              {userData?.pan_ownership?.is_editable ? (
                <S.InfoTextWrap>
                  <S.InfoText>{booking_tds || ''}%</S.InfoText>
                  {showSpinnerUpdateTds ? (
                    <Spinner width="32px" height="32px" borderWidth="4px" />
                  ) : (
                    <S.VerifiedTag>
                      <S.VerifyEmailLink onClick={postUpdateTdsSlab}>Update</S.VerifyEmailLink>
                    </S.VerifiedTag>
                  )}
                </S.InfoTextWrap>
              ) : (
                <S.InfoText>{booking_tds || ''}%</S.InfoText>
              )}
            </S.ProfileInfoInnerWrap>
          ) : null}

          {showUpdateAgremeentRow && (
            <S.ProfileInfoInnerWrap>
              <S.InfoTitleWrap>
                <S.TitleText>{userData?.tnc_completed?.agreement_row?.text}</S.TitleText>
              </S.InfoTitleWrap>
              {!userData?.tnc_completed?.agreement_accepted ? (
                <S.InfoTextWrap>
                  {<S.VerifyEmailLink onClick={handleAgreementClick}>Update</S.VerifyEmailLink>}
                </S.InfoTextWrap>
              ) : (
                <S.TitleText>Agreement Accepted</S.TitleText>
              )}
            </S.ProfileInfoInnerWrap>
          )}
        </S.ProfileInfoOuterWrap>
      </S.ProfileInnerWrap>

      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        hideCloseButton={true}
        modalStyles={{
          width: '40vw',
        }}
      >
        <AadharOtpVerify
          closeModal={closeModal}
          submitOtp={submitAadharOtp}
          errorText={otpError}
          resentOtp={resendOtp}
          clickActive={resendOtpActive}
        />
      </Modal>

      {(showPop && (
        <EmailOtpVerify
          closePop={closeVerifyPop}
          userEmail={email}
          errorEmailText={emailOtpError}
          resentEmailOtp={resentEmailOtp}
          clickEmailActive={resendEmailOtpActive}
          submitEmailOtp={submitEmailOtp}
          sendEmailOtp={data => sendEmailOtp(data)}
          btnLoad={isEmailLoading}
          existingEmail={emailExist}
        />
      )) ||
        null}

      {(showVerifiedPop && (
        <EmailVerified closePop={closeVerifiedPop} email={newEmail ? newEmail : email} />
      )) ||
        null}

      {showUnlinkPop && (
        <UnlinkMobilePop
          userNumber={username}
          resendOtp={resendUnlinkOtp}
          clickActive={resendUnlinkOtpActive}
          closePop={closeUnlinkPop}
          errorUnlinkOtp={unlinkOtpError}
          submitUnlinkOtp={submitUnlinkOtp}
        />
      )}
      {showToggleMaskPop && (
        <MobilePop
          userNumber={username}
          resendOtp={resendMaskOtp}
          clickActive={resendMaskOtpActive}
          closePop={closeToggleMaskPop}
          errorUnlinkOtp={maskOtpError}
          submitOtp={submitMaskOtp}
        />
      )}
      {showUpdateMobilePop && (
        <UpdateMobile
          userNumber={username}
          closePop={closeUpdatePop}
          sendMobileOtp={data => submitNumber(data)}
          resendOtp={resendUpdateOtp}
          clickActive={resendUpdateActive}
          numberExist={mobileExist}
          errorUpdateOtp={updateOtpError}
          btnLoad={isSendOtpLoading}
          submitUpdateOtp={submitUpdateOtp}
        />
      )}

      {showMobileVerify && (
        <MobileVerified closePop={closeMobVerifiedPop} mobile={mobile_number} email={email} />
      )}

      {(showUpdateEmail && (
        <UpdateEmail
          closePop={closeUpdateVerifiedEmailPop}
          userEmail={email}
          errorEmailText={emailOtpError}
          resentEmailOtp={resentUpdateEmailOtp}
          clickEmailActive={resendEmailOtpActive}
          submitEmailOtp={submitUpdateEmailOtp}
          sendEmailOtp={data => sendUpdateVerifiedEmail(data, 'new')}
          btnLoad={isEmailLoading}
          existingEmail={emailExist}
          showNewEmailInput={showNewEmailInput}
          newEmail={newEmail}
        />
      )) ||
        null}
      {openModalFlag && (
        <Modal
          isOpen={openModalFlag}
          closeModal={closeFormModal}
          hideCloseButton={true}
          modalStyles={{
            width: '60rem',
          }}
        >
          {popupType === 'OTP_VERIFIED' ? (
            <OtpVerfied
              heading={communicationAddress?.heading}
              subHeading={communicationAddress?.text}
              headingIcon={true}
              inportantInfo={communicationAddress?.sub_text}
            />
          ) : (
            <UpdateDetailsForm
              {...modalData}
              successCallback={popupSuccessCallback}
              errorCallback={popupErrorCallback}
              errorMessages={errorForm}
              closeModal={closeFormModal}
            />
          )}
        </Modal>
      )}
    </S.ProfileMainWrap>
  );
};

export default ProfileInfo;
